import React, { useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useStyles } from "./UptimeDowntimeBar.styles";
import { IUptimeDowntimeBar } from "./UptimeDowntimeBarInterfaces";

export const UptimeDowntimeBar = ({ productionLineName, uptimeValue, downtimeValue }: IUptimeDowntimeBar) => {
    const classes = useStyles();
    const [uptimePercentage, setUptimePercentage] = useState<null | number>(null);
    const [downtimePercentage, setDowntimePercentage] = useState<null | number>(null);

    useMemo(() => {
        setDowntimePercentage(Math.ceil((downtimeValue / (downtimeValue + uptimeValue)) * 100));
        setUptimePercentage(Math.floor((uptimeValue / (downtimeValue + uptimeValue)) * 100));
    }, [uptimeValue, downtimeValue]);

    return (
        <Box className={classes.container}>
            <Box className={classes.machineTitleContainer}>
                <Typography variant="error" className={classes.title}>
                    {productionLineName}
                </Typography>
                <Box className={classes.percentagesContainter}>
                    <Typography variant="subtitle2" className={classes.uptimeTitle}>
                        {`${uptimePercentage}%`}
                    </Typography>
                    <Typography variant="subtitle2" className={classes.downtimeTitle}>
                        {`${downtimePercentage}%`}
                    </Typography>
                </Box>
            </Box>
            <Box className={classes.progressBar}>
                <Box className={classes.uptime} sx={{ width: `${uptimePercentage}%` }}></Box>
                <Box className={classes.downtime} sx={{ width: `${downtimePercentage}%` }}></Box>
            </Box>
        </Box>
    );
};
